import _ from 'lodash';
import { constantsActive } from 'utils/constants/constants'
import HelperAvailability from "utils/helper/HelperAvailability";
import { bookingConstants } from 'utils/constants/booking-constants'
import { routeBookingConstants } from 'utils/constants/route/RouteBookingConstants'
import store from 'services/redux/store'
import { dataConstants } from 'services/redux/data/constants'

const HelperLocation = {
	
	_timeslotKinds: null,
	
	buildTree: ( buildings, floors, rooms, timeslotKinds, timeslotSubKinds, forcedGuids = {} ) => {
		HelperLocation._timeslotKinds = store.getState().data[ dataConstants.TIMESLOT_KINDS ];
		
		let list = {};
		
		_.forEach( buildings, ( building ) => {
			// Not active? next in loop
			if( building.active === constantsActive.NO ) {
				return true;
			}
			
			// Not same guid? next in loop
			if( _.get( forcedGuids, routeBookingConstants.FORCED_BUILDING_GUID , building.guid ) !== building.guid ) {
				return true;
			}
			
			const buildingHasRequiredTimeslots = HelperLocation.hasRequiredTimeslots( _.get( building, 'timeslots_through', [] ), timeslotKinds, timeslotSubKinds, forcedGuids );
			
			let buildingFloors = {};
			_.forEach( _.get( building, 'floors', [] ), ( floor ) => {
				floor = floors[ floor.guid ];
				
				// Undefined? next in loop
				if( typeof floor === 'undefined' ) {
					return true;
				}
				
				if( floor.active === constantsActive.NO ) {
					return true;
				}
				
				// Not available? next in loop
				if( !HelperAvailability.isAvailable( bookingConstants.FLOOR, floor ) ) {
					return true;
				}
				
				// Not same guid? next in loop
				if( _.get( forcedGuids, routeBookingConstants.FORCED_FLOOR_GUID, floor.guid ) !== floor.guid ) {
					return true;
				}
				
				const floorHasRequiredTimeslots = HelperLocation.hasRequiredTimeslots( _.get( floor, 'timeslots_through', [] ), timeslotKinds, timeslotSubKinds, forcedGuids);
				
				let floorRooms = {};
				_.forEach( _.get( floor, 'rooms', [] ), ( room ) => {
					room = rooms[ room.guid ];
					
					// Undefined? next in loop
					if( typeof room === 'undefined' ) {
						return true;
					}
					
					if( room.active === constantsActive.NO ) {
						return true;
					}
					
					// Not available? next in loop
					if( !HelperAvailability.isAvailable( bookingConstants.ROOM, room ) ) {
						return true;
					}
					
					// Not same guid? next in loop
					if( _.get( forcedGuids, routeBookingConstants.FORCED_ROOM_GUID , room.guid ) !== room.guid ) {
						return true;
					}
					
					const roomHasRequiredTimeslots = HelperLocation.hasRequiredTimeslots( _.get( room, 'timeslots_through', [] ), timeslotKinds, timeslotSubKinds, forcedGuids );
					
					if( roomHasRequiredTimeslots ) {
						floorRooms[ room.guid ] = {
							...room
						};
					}
				});
				
				if ( floorHasRequiredTimeslots || _.size( floorRooms ) > 0 ) {
					buildingFloors[ floor.guid ] = {
						...floor,
						rooms: floorRooms
					};
				}
			});
			
			if ( buildingHasRequiredTimeslots || _.size( buildingFloors ) > 0 ) {
				list[ building.guid ] = {
					...building,
					floors: buildingFloors
				};
			}
		});
		
		return list;
	},
	
	hasRequiredTimeslots: ( timeslots, timeslotKinds, timeslotSubKinds, forcedGuids ) => {
		if( _.size( timeslots ) === 0 ) {
			return false;
		}
		
		return _.filter( timeslots, ( timeslot ) => {
			if( forcedGuids[ routeBookingConstants.FORCED_TIMESLOTS ] !== undefined  ){
				if( !_.includes( forcedGuids[ routeBookingConstants.FORCED_TIMESLOTS ], _.get( HelperLocation._timeslotKinds, [ `${timeslot?.kind}_${timeslot?.sub_kind}`, 'guid' ], null  ) ) ){
					return false;
				}
			}
			
			return ( timeslot?.active === constantsActive.YES && _.includes( timeslotKinds, timeslot?.kind ) && _.includes( timeslotSubKinds, timeslot?.sub_kind ) );
		}).length > 0;
	},
	
	hasRequiredAccess: ( buildTree, forcedGuids ) => {
	
	}
}

export default HelperLocation;
